import * as constants from '@/common/constants';
import { get, post, del } from '@/utils/http';

export const getProcessInstancesCnt = (params) => {
    return post(constants.API_PROCESS_INSTANCES_CNT, params);
};

export const getProcessInstancesList = (params = {}) => {
    return post(constants.API_PROCESS_INSTANCES_LIST, params);
};

export const getAllProcessInstancesList = (params = {}) => {
    return post(constants.API_PROCESS_ALL_INSTANCES_LIST, params);
};

export const getProcessInstancesUsers = (params) => {
    return post(constants.API_PROCESS_INSTANCES_USERS, params);
};

export const getProcessInstancesDetail = (instanceId) => {
    return get(constants.API_PROCESS_INSTANCES_DETAIL.replace(':instanceId', instanceId));
};

export const cancelProcessInstance = (instanceId) => {
    return del(constants.API_PROCESS_INSTANCES_CANCEL.replace(':instanceId', instanceId));
};

export const deleteProcessInstance = (instanceId) => {
    return del(constants.API_PROCESS_INSTANCES_DELETE.replace(':instanceId', instanceId));
};

export const suspendProcessInstance = (instanceId) => {
    return post(constants.API_PROCESS_INSTANCES_SUSPEND.replace(':instanceId', instanceId));
};

export const activiteProcessInstance = (instanceId) => {
    return post(constants.API_PROCESS_INSTANCES_ACTIVITE.replace(':instanceId', instanceId));
};
export const terminalProcessInstance = (params) => {
    return post(constants.API_PROCESS_INSTANCES_TERMINAL, params);
};

export const getProcessInstancesRecordList = (processInstanceId, orderBy) => {
    return get(constants.API_PROCESS_INSTANCES_RECORD_LIST, { processInstanceId: processInstanceId, orderBy: orderBy });
};

export const getProcessInstanceAdjList = (params) => {
    return get(constants.API_PROCESS_INSTANCES_ADJ_LIST, params);
};

export const getProcessInstancesCommentList = (params) => {
    return get(constants.API_PROCESS_INSTANCES_COMMENT_LIST, params);
};

export const saveProcessInstancesComment = (params) => {
    return post(constants.API_PROCESS_INSTANCES_COMMENT_SAVE, params);
};

export const deleteProcessInstancesComment = (commentId) => {
    return del(constants.API_PROCESS_INSTANCES_COMMENT_DELETE.replace(':commentId', commentId));
};

export const sendApprovalCommentMsg = (params) => {
    return post(constants.API_PROCESS_TASK_COMMENT_SENDMSG, params);
};

export const getProcessModelForms = (params) => {
    return post(constants.API_PROCESS_INSTANCES_MODELFORMS, params);
};

export const getProcessAllFormInstances = (params) => {
    return post(constants.API_PROCESS_INSTANCES_ALLFORMINSTANCE, params);
};

export const getAllProcessTaskForms = (params) => {
    return post(constants.API_PROCESS_INSTANCES_ALL_FORMS, params);
};

export const getProcessInstanceFormsAuth = (params) => {
    return post(constants.API_PROCESS_INSTANCES_FORMS_AUTH, params);
};

export const saveProcessInstanceFormAuth = (params) => {
    return post(constants.API_PROCESS_INSTANCES_SAVE_FORMS_AUTH, params);
};

export const getProcessInstanceFiles = (params) => {
    return get(constants.API_PROCESS_INSTANCES_GET_FILES, params);
};

export const getApprovalInstanceFiles = (params) => {
    return get(constants.API_APPROVAL_INSTANCES_GET_FILES, params);
};

export const delProcessFile = (params) => {
    return post(constants.API_PROCESS_INSTANCES_DELETE_FILE, params);
};

export const getAllUserTask = (instanceId, serviceId, processDefinitionId, deploymentId) => {
    if (processDefinitionId) {
        return get(constants.API_PROCESS_INSTANCES_ALLUSERTASK.replace(':instanceId', '-1').replace(':serviceId', serviceId).replace(':processDefinitionId', processDefinitionId).replace(':deploymentId', deploymentId));
    } else {
        return get(constants.API_PROCESS_INSTANCES_ALLUSERTASK.replace(':instanceId', instanceId).replace(':serviceId', serviceId).replace(':processDefinitionId', '-1').replace(':deploymentId', deploymentId));
    }
};

export const getPubliclibraryFiles = (params) => {
    return get(constants.API_DOCUMENT_PUBLICLIBRARY_GET_FILES, params);
};

export const getPubliclibraryFileList = (params) => {
    return get(constants.API_DOCUMENT_PUBLICLIBRARY_GET_FILELIST, params);
};

/** 设置共享 */
export const updShareInner = (params) => {
    return post(constants.API_DOCUMENT_PUBLICLIBRARY_UPDSHAREINNER, params);
};
/** 移动文件 */
export const addMoveFile = (params) => {
    return post(constants.API_DOCUMENT_PUBLICLIBRARY_ADDMOVEFILE, params);
};

/** 档案模板获取模板文件夹 */
export const getArchiveTemplateFiles = (params) => {
    return get(constants.API_ARCHIVE_TEMPLATE_GET_FILES, params);
};

/** 移动文件(档案模板) */
export const addMoveArchiveFile = (params) => {
    return post(constants.API_ARCHIVE_TEMPLATE_FILE_ADDMOVEFILE, params);
};

/** 档案模板实例获取模板文件夹及文件 */
export const getArchiveTemplateInstanceFiles = (params) => {
    return get(constants.API_ARCHIVE_TEMPLATE_GET_INSTANCE_FILES, params);
};

/** 流程文件列表 */
export const getProcessFiles = (params) => {
    return post(constants.API_PROCESS_INSTANCES_GET_PROCESSFILES, params);
};

/** 流程实例抄送人信息列表 */
export const getProcessInstanceCopyUserList = (params) => {
    return get(constants.API_PROCESS_PROCESS_COPY_USER_LIST, params);
};

/** 修改流程实例抄送人信息 */
export const saveProcessInstanceCopyUsers = (params) => {
    return post(constants.API_PROCESS_PROCESS_COPY_USER_UPD, params);
};
// getModelFormDetail
/** 审批获取模型的表单 */
export const getModelFormDetail = (params) => {
    return get(constants.API_CUSTOMFORM_GETMODELFORMDETAIL, params);
};

export const getTaskMenuList = (processServiceId) => {
    return get(constants.API_PROCESS_INSTANCES_TASKMENULIST.replace(':processServiceId', processServiceId));
};
/** 查询流程实例增在进行中的任务 */
export const getProcessCurrentTasks = (processInstanceId, param) => {
    return get(constants.API_PROCESS_INSTANCES_CURRENTTASKLIST.replace(':processInstanceId', processInstanceId), param);
};
export const jumpTaskProcessInstances = (params) => {
    return post(constants.API_PROCESS_INSTANCES_POST_JUMPTASKPROCESSINSTANCES, params);
};



// WEBPACK FOOTER //
// ./src/data-model/process/instances-model.js